import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const InsightContent = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <line x1="4" y1="6" x2="14" y2="6" />
        <line x1="4" y1="12" x2="20" y2="12" />
        <line x1="4" y1="18" x2="11" y2="18" />
        <circle cx="17" cy="6" r="2" />
        <circle cx="8" cy="18" r="2" />
      </svg>
    )
  },
)

export default InsightContent
